// Mobile dropdown menu - when the user clicks on the button, toggle between hiding and showing the dropdown content
function mySecondFunction() {
    document.getElementById("mySecondDropdown").classList.toggle("show");
}

// Close the dropdown menu if the user clicks outside of it
document.addEventListener('click', function(event) {
    if (!event.target.matches('.ec-dropbtn, .ec-dropbtn img')) {
        var dropdowns = document.getElementsByClassName("ec-dropdown-content");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
            var openDropdown = dropdowns[i];
            if (openDropdown.classList.contains('show')) {
                openDropdown.classList.remove('show');
            }
        }
    }
});

// All other button & menu functionality
document.addEventListener('DOMContentLoaded', function() {
    const dropdownButton = document.querySelector('.ec-dropbtn');
    const dropdownIcon = '<img src="//futurestitch.com/cdn/shop/t/20/assets/chevron-down.svg?v=6191995480804421341769620946" alt="down chevron" />';
    const dropdownItems = document.querySelectorAll('.ec-dropdown-content a');
    const desktopMenuButtons = document.querySelectorAll('.ec-desktop-menu a');

    function displayContent(blockTitle) {
        const contentToShow = document.getElementById('ec-content-' + blockTitle);
        if (contentToShow) {
            const allContents = document.querySelectorAll('.ec-container-2');
            allContents.forEach(content => content.style.display = 'none');

            contentToShow.style.display = 'block';
            dropdownButton.innerHTML = blockTitle + dropdownIcon;
        }
    }

    function updateDesktopMenuSelection(blockTitle) {
        desktopMenuButtons.forEach(button => {
            button.classList.remove('selected');
            if (button.textContent.trim() === blockTitle) {
                button.classList.add('selected');
            }
        });
    }

    function updateDropdownContentVisibility(blockTitle) {
        dropdownItems.forEach(item => {
            item.style.display = item.textContent.trim() === blockTitle ? 'none' : 'block';
        });
    }

    function navigateToBlock(blockIndex) {
        const blocks = document.querySelectorAll('.ec-container-2');
        const blockTitle = desktopMenuButtons[blockIndex].textContent.trim();

        blocks.forEach((block, index) => block.style.display = index === blockIndex ? 'block' : 'none');
        dropdownButton.innerHTML = blockTitle + dropdownIcon;
        updateDesktopMenuSelection(blockTitle);
        updateDropdownContentVisibility(blockTitle);
    }

    dropdownItems.forEach((item, index) => item.addEventListener('click', e => {
        e.preventDefault();
        navigateToBlock(index);
    }));

    desktopMenuButtons.forEach((button, index) => button.addEventListener('click', e => {
        e.preventDefault();
        navigateToBlock(index);
    }));

    navigateToBlock(0);
});